import FollowersSummary from "./FollowersSummary";

export default FollowersSummary;
